
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  PdaUsercodename,
  DestinationOrgcodename,
  LineListcodename
} from "@/views/components";

@Component({
  name: "Form1",
  components: {
    PdaUsercodename,
    DestinationOrgcodename,
    LineListcodename
  },
  props: {
    callbackdata: {
      type: Object,
      default: false
    }
  },
  watch: {
    callbackdata(newone, oldone) {
      this.inputModel = newone;
    }
  }
})
export default class extends Vue {
  @Watch("inputModel.input_Weight", { deep: false })
  oninputWeightChanged(val: string) {
    if (this.isNumber(val)) {
      // this.inputModel.input_Weight = val.replace(/[^\0-9\.]/g, "");
    } else {
      this.$message({
        message: "请输入正确的数字",
        type: "error"
      });

      this.inputModel.input_Weight = this.inputModel.input_Weight.substr(
        0,
        this.inputModel.input_Weight.length - 1
      );
    }
  }

  @Watch("inputModel.input_TempWeight", { deep: false })
  oninputTempWeightChanged(val: string) {
    if (this.isNumber(val)) {
      // this.inputModel.input_TempWeight = val.replace(/[^\0-9\.]/g, "");
    } else {
      this.$message({
        message: "请输入正确的数字",
        type: "error"
      });

      this.inputModel.input_TempWeight =
        this.inputModel.input_TempWeight.substr(
          0,
          this.inputModel.input_TempWeight.length - 1
        );
    }
  }
  public CarCodelockedChangeFunc(isChecked) {
    console.log(this.inputModel.checked_AutoCreateCarCode);
    console.log(isChecked);
    if (isChecked) {
      if (this.inputModel.checked_AutoCreateCarCode) {
        this.$message({
          message: "请先取消勾选自动生成车签",
          type: "error",
        });
        this.$nextTick(() => {
          this.inputModel.checked_CarCodelocked = false;
        });
      }
    }
  }
  public delValue() {
    this.inputModel.input_NextWebPoint = "";
  }
  public input_TempWeightBlurFunc() {
    if (this.inputModel.input_TempWeight.length < 1) {
      this.inputModel.input_TempWeight = "1";
    }
  }
  public input_WeightBlurFunc() {
    if (this.inputModel.input_Weight.length < 1) {
      this.inputModel.input_Weight = "0";
    }
  }
  private isNumber(value) {
    //验证是否为数字
    if (!isNaN(value)) {
      return true;
    } else {
      return false;
    }
  }
  private inputModel: inputDataModel = {
    checked_IsSumWeight: false,
    checked_IsOverTimeCar: false,
    checked_AutoCreateCarCode: false,
    checked_NeedWeight: false,
    input_CarLabel: "",
    checked_CarCodelocked: false,
    input_PacketCode: "",
    input_PanelLine: "",
    input_PanelLineName: "",
    input_NextorgSelect: "",
    input_NextWebPoint: "",
    input_CarNumInfo: "",
    input_RecvType: "",
    checked_RecvTypeLock: false,
    input_Weight: "",
    checked_IsCheckBagWeight: false,
    input_TempWeight: "1",
    input_ScanCode: "",
    input_warehouseFlag:"",
    input_StartSoundPlay:false,
    warehouseFlagVisible:false,
    soundPlayDisable:true,
  };
  mounted() {
    this.InitIoTypeFunc();
    this.InitConfig();
    obj_ScanForGetOn.regist_NextOrgs(this.nextorgscallback);
  }
  @Watch("inputModel", { deep: true })
  onChildChanged(val: string) {
    this.$emit("get-form1-value", val);
  }
  @Watch("inputModel.input_NextWebPoint", { deep: false })
  onNextWebPointChanged(val: string) {
    this.$emit("choose-next-web-point", val);
  }

  public SearchNextOrg() {
    let nextWebPoint = this.selectRemote.trim().toUpperCase();
    let nextwebpointStr = obj_ScanForGetOn.nextWebPoint_KeyPress(nextWebPoint);
    if (nextwebpointStr != null && nextwebpointStr.length > 0) {
      let nextwebpoint = JSON.parse(nextwebpointStr);
      if (nextwebpoint.respcode == "000") {
        this.inputModel.input_NextorgSelect = nextwebpoint.data.nextOrgCodeName;
        this.inputModel.input_NextWebPoint = nextwebpoint.data.queryNo;
        this.$emit("choose-next-web-point", nextwebpoint.data.queryNo);
      } else {
        this.errormessage = nextwebpoint.respMessage;
      }
      debugger;
    } else {
      this.errormessage = "下一网点查询失败，返回结果为空";
    }
  }
  public selectRemote = "";
  public dataFilter(data) {
    this.selectRemote = data;
  }
  public nextorgscallback(datas) {
    var jsonobj = JSON.parse(datas);
    if (jsonobj.data.busiDataArray != null) {
      this.options_NextOrg = [];
      jsonobj.data.busiDataArray.forEach((element) => {
        this.options_NextOrg.push({
          label: element.endOrgName,
          value: element.endOrgCode,
          orgtype: element.endOrgType,
        });
      });
    }
    this.$emit("optionsNextOrg", this.options_NextOrg);
  }
  public options_IoType = [];
  public initIoTypesCallback(datas) {
    this.options_IoType = [];
    datas.forEach((element) => {
      this.options_IoType.push({
        label: element,
        value: element,
      });
    });
    if (this.options_IoType.length > 0) {
      this.inputModel.input_RecvType = "正常";
    }
  }

  public checked_IsCheckBagWeightVisible = false;
  public InitConfig() {
    var _configData: configData = obj_ScanForGetOn.getScanForGetOnConfig();

    this.input_PutInWeightVisible = _configData.isWeightShow;
    this.checked_IsCheckBagWeightVisible = _configData.isCheckBagWeightShow;
  }
  public input_PutInWeightVisible = false;
  public input_OverWeightValueVisible = false;
  public RecheckBagWeightFunc(result) {
    if (result) {
      this.input_OverWeightValueVisible = true;
    } else {
      this.input_OverWeightValueVisible = false;
    }
  }
  public linecodenameDialogVisible = false;
  public findlinecodename() {
    this.linecodenameDialogVisible = true;
    //obj_ScanForGetOn.loadlinedata(10, 1, "", this.initlinedata);
  }

  public InitIoTypeFunc() {
    obj_ScanForGetOn.initIoTypes(this.initIoTypesCallback);
  }
  private clearlinecodename() {
    this.inputModel.input_PanelLine = "";
    this.inputModel.input_PanelLineName = "";
    this.inputModel.input_NextWebPoint = "";
    this.inputModel.input_NextorgSelect = "";
    this.options_NextOrg = [];
  }

  private linelistdialogshow = false;
  public linelistcodenameFunc(linelistModel) {
    this.linelistdialogshow = false;
    if (linelistModel != null) {
      this.inputModel.input_PanelLine = linelistModel.lineNo;
      this.inputModel.input_PanelLineName = linelistModel.lineName;
      obj_ScanForGetOn.panel_line_ValueChanged(
        linelistModel.lineNo,
        linelistModel.lineName
      );
    }
  }
  public NextWebPointChangeFunc(NextWebPoint) {}
  //下一网点选择
  private chooseNextOrgCode(item): void {
    this.inputModel.input_NextWebPoint = item.value;
    this.$emit("choose-next-web-point", item.value);
  }
  public findlinelistcodename() {
    this.linelistdialogshow = true;
  }
  public input_RecvTypeDisable = false;
  public checkIoTypeFunc() {
    if (this.inputModel.checked_RecvTypeLock == true) {
      if (this.inputModel.input_RecvType.length > 0) {
        this.input_RecvTypeDisable = true;
      } else {
        this.inputModel.checked_RecvTypeLock = false;
      }
    } else {
      this.input_RecvTypeDisable = false;
    }
  }
  public options_NextOrg = [];
  public list_DestinationOrg = [];
  //初始化组织
  private initorgcode(datas): void {
    this.list_DestinationOrg = [];
    var jsonobj = JSON.parse(datas);
    if (jsonobj.respcode == "000") {
      var allorgcodes = jsonobj.data.busiData.records;
      allorgcodes.forEach((element) => {
        this.list_DestinationOrg.push({
          value: element.name,
          label: element.code,
        });
      });
    } else {
      console.log("err" + jsonobj);
    }
  }

  //初始化线路
  private initlinedata(datas): void {
    this.list_LineData = [];
    var jsonobj = JSON.parse(datas);
    if (jsonobj.respcode == "000") {
      var alllinedata = jsonobj.data.busiData.records;
      alllinedata.forEach((element) => {
        this.list_LineData.push({
          value: element.transType + "|" + element.lineName,
          label: element.lineNo,
        });
      });
    } else {
      console.log("err" + jsonobj);
    }
  }

  //显示信息栏
  public messageboxShow(type, msg): void {
    // info
    // warning
    // success
    // error
    this.$message({
      message: msg,
      type: type,
    });
  }

  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  //表格选中当前行
  public setCurrent(row) {
    this.$refs.singleTable[0].setCurrentRow();
  }

  //更新线路数据
  public remoteMethod_loadlinedata(query): void {
    if (query !== "") {
      this.loading_LineData = true;
      setTimeout(() => {
        this.loading_LineData = false;
        obj_ScanForGetOn.loadlinedata(query, this.initlinedata);
        this.options = this.list_LineData.filter((item) => {
          return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      }, 1000);
    } else {
      this.options = [];
    }
  }

  public loading_DestinationOrg = false;
  public loading_LineData = false;
  public list_LineData = [];
  public options = [];
  private form = null;
  private errormessage = "";
}
